import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './styles.scss';

export default function Column({ children, cols, tdStyle }) {
    const tdCols = {
        className: `tdStyle ${styles[tdStyle]}`,
    };

    if (cols) { tdCols.colSpan = cols; }

    return (
        <td {...tdCols}>
            {children}
        </td>
    );
}

Column.displayName = displayName('Forms/InputGroup/Column');

Column.propTypes = {
    children: PropTypes.node,
    cols: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    tdStyle: PropTypes.string,
};

Column.defaultProps = {
    tdStyle: 'column',
    children: null,
    cols: '',
};
